import React, { useEffect, createElement } from 'react';
import { ArticleHeader } from './components/ArticleHeader';
import { ArticleBody } from './components/ArticleBody';
import { Banner } from './components/Banner';
import { Sidebar } from './components/Sidebar';
import { ReviewsSection } from './components/ReviewsSection';
import { OfferSection } from './components/OfferSection';
import { FooterLogo } from './components/FooterLogo';
export function App() {
  useEffect(() => {
    // Microsoft Clarity tracking code
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "w17mvcbm5v");
    `;
    document.head.appendChild(script);
    // Klarinsights tracking code
    const script2 = document.createElement('script');
    script2.type = 'text/javascript';
    script2.innerHTML = `
      (function () {
        var a = document.createElement('script');
        (a.type = 'text/javascript'),
          (a.async = !0),
          (a.src = 'https://september.klarinsights.net/javascript/1868949547/SHOPWARE_V6/v2.js'),
          document.getElementsByTagName('script')[0].parentNode.appendChild(a);
      })();
    `;
    document.head.appendChild(script2);
  }, []);
  return <div className="w-full min-h-screen bg-white mx-auto relative" style={{
    maxWidth: 1120,
    fontFamily: 'Figtree, sans-serif'
  }} data-id="element-0">
      {/* Main content area with sidebar */}
      <div className="relative" data-id="element-1">
        {/* Main article column */}
        <div className="pt-6 md:pt-[61px]" style={{
        maxWidth: 783,
        paddingLeft: 15,
        paddingRight: 15
      }} data-id="element-2">
          <ArticleHeader data-id="element-3" />
        </div>

        {/* Sidebar - fixed on desktop, stays visible while scrolling */}
        <div className="hidden lg:block fixed" style={{
        top: 256,
        right: 'calc(50% - 560px + 30px)'
      }} data-id="element-4">
          <Sidebar data-id="element-5" />
        </div>
      </div>

      {/* Full-width banner */}
      <div style={{
      marginTop: 27
    }} data-id="element-6">
        <Banner data-id="element-7" />
      </div>

      {/* Article body content */}
      <div style={{
      maxWidth: 783,
      padding: '4px 15px 0 15px'
    }} data-id="element-8">
        <ArticleBody data-id="element-9" />
      </div>

      {/* Reviews section - same width as article body */}
      <div className="mt-8" style={{
      maxWidth: 783,
      padding: '0 15px'
    }} data-id="element-10">
        <ReviewsSection data-id="element-11" />
      </div>

      {/* Offer section - same width as article body */}
      <div style={{
      maxWidth: 783,
      padding: '0 15px'
    }} data-id="element-12">
        <OfferSection data-id="element-13" />
      </div>

      {/* Legal links */}
      <div className="flex justify-between items-center" style={{
      maxWidth: 783,
      padding: '16px 80px 0 80px',
      fontFamily: 'Figtree, sans-serif'
    }} data-id="element-14">
        <a href="https://maleup.de/policies/legal-notice" target="_blank" rel="noopener noreferrer" style={{
        fontSize: 13,
        color: '#999999',
        textDecoration: 'none'
      }} data-id="element-15">
          Impressum
        </a>
        <a href="https://maleup.de/policies/privacy-policy" target="_blank" rel="noopener noreferrer" style={{
        fontSize: 13,
        color: '#999999',
        textDecoration: 'none'
      }} data-id="element-16">
          Datenschutzerklärung
        </a>
      </div>

      {/* Footer logo */}
      <FooterLogo data-id="element-17" />
    </div>;
}